import '../../tables/ledger/neb-table-ar-hub';
import '../../../../packages/neb-lit-components/src/components/neb-pagination';
import { openPopup } from '@neb/popup';
import { css, html, LitElement } from 'lit';

import { bulkUpdateBilledStatus } from '../../../../packages/neb-api-client/src/invoice-api-client';
import {
  openError,
  openSuccess,
} from '../../../../packages/neb-dialog/neb-banner-state';
import {
  openOverlay,
  OVERLAY_KEYS,
} from '../../../../packages/neb-lit-components/src/utils/overlay-constants';
import { POPUP_RENDER_KEYS } from '../../../../packages/neb-popup/src/renderer-keys';
import { store } from '../../../../packages/neb-redux/neb-redux-store';
import Debouncer from '../../../../packages/neb-utils/debouncer';
import '../../../../packages/neb-lit-components/src/components/tables/neb-table';
import '../../overlays/ledger/ar-hub/neb-overlay-manage-columns';
import { CSS_SMALL_SPACING, CSS_SPACING } from '../../../styles';
import {
  CONFIG,
  getFilteredColumns,
} from '../../../utils/ar-hub/column-definitions';
import { MODE } from '../../controls/buttons/neb-button-menu';

import exportData from './neb-page-ar-hub-new-custom-view/export-data';

export const ELEMENTS = {
  table: { id: 'table' },
  showHideColumnsButton: { id: 'show-hide-columns-button' },
  exportDataButton: { id: 'export-data-button' },
  addFollowUpButton: { id: 'add-follow-up-button' },
  updateBilledStatusButton: { id: 'update-billed-status-button' },
  viewNotesButton: { id: 'view-notes-button' },
  pagination: { id: 'pagination' },
};

const EMPTY_MESSAGE = 'No results found, please adjust your filters';
const FILTER_PROMPT_MESSAGE = 'Please select filters to display results';

const PAGE_SIZE = 100;
class NebPageArHubNewCustomView extends LitElement {
  static get properties() {
    return {
      model: Array,
      sortParams: Array,
      isInvoiceOverlayClosed: Boolean,
      config: { type: Array },
      allColumns: { type: Array },
      columns: { type: Array },
      selectedItems: Array,
      showFilterPrompt: { type: Boolean },
      billedStatuses: { type: Array },
      __pageIndex: { type: Number },
      __pageCount: { type: Number },
      __pagedItems: { type: Array },
      __selectedItemsForCurrentPage: { type: Array },
    };
  }

  static get styles() {
    return css`
      .button-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${CSS_SMALL_SPACING};
        grid-auto-flow: row dense;
        padding: ${CSS_SMALL_SPACING} ${CSS_SPACING};
      }

      .left-buttons {
        justify-self: start;
      }

      .right-buttons {
        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-auto-flow: row dense;
        justify-items: end;
        justify-self: end;
      }

      .right-buttons neb-button-menu {
        z-index: 99;
      }

      .export-data-button {
        width: 200px;
      }

      neb-pagination {
        justify-content: flex-end;
        margin: 20px 20px 100px 20px;
      }
    `;
  }

  constructor() {
    super();
    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.model = [];
    this.sortParams = [];
    this.isInvoiceOverlayClosed = false;
    this.selectedItems = [];
    this.config = getFilteredColumns();
    this.debouncer = new Debouncer();
    this.billedStatuses = [];

    this.allColumns = CONFIG.map(column => ({
      key: column.key,
      label: column.label,
      selected: getFilteredColumns().some(c => c.key === column.key),
    }));

    this.columns = [...this.config];

    this.onChangeSort = () => {};

    this.onClickInvoice = () => {};

    this.onClickCase = () => {};

    this.onClickERAsEOBs = () => {};

    this.onFollowUpAdded = () => {};

    this.onClickFollowUp = () => {};

    this.onSetColumns = () => {};

    this.onCompleteFollowUp = () => {};

    this.onUpdateBilledStatus = () => {};

    this.onPrimaryPayerClick = () => {};

    this.onSecondaryPayerClick = () => {};

    this.__sortDebouncer = new Debouncer(() => {
      const result = this.__pendingSortResult;
      this.sortParams = [result[0]];
      const { key, dir } = result[0];
      this.onChangeSort(key, dir);
    }, 200);

    this.__pageIndex = 0;
    this.__pageCount = 1;
    this.__pagedItems = [];
    this.__selectedItemsForCurrentPage = [];
    this.__totals = {
      billedAmount: 0,
      allowedAmount: 0,
      adjustmentAmount: 0,
      payerBalance: 0,
      patientBalance: 0,
      balance: 0,
    };
  }

  __initHandlers() {
    this.__handlers = {
      onSort: (_name, result) => {
        this.__pendingSortResult = result;
        this.__sortDebouncer.debounce();
      },
      onClickInvoice: row => {
        this.onClickInvoice(row);
      },
      onClickCase: row => {
        this.onClickCase(row);
      },
      onClickERAsEOBs: row => {
        this.onClickERAsEOBs(row);
      },
      onClickFollowUp: () => {
        this.onClickFollowUp();
      },
      completeFollowUp: ({ followUpId, isCompleted, rowIndex }) => {
        this.onCompleteFollowUp({ followUpId, isCompleted, rowIndex });
      },
      exportData: (withPtInsInfo = false) =>
        exportData({
          model: this.model,
          config: this.config,
          withPtInsInfo,
        }),
      showHideColumns: async () => {
        const columns = this.config.map(column => ({
          key: column.key,
          label: column.label,
          selected: true,
        }));

        const unselectedColumns = CONFIG.filter(
          column => !columns.some(c => c.key === column.key),
        ).map(column => ({
          key: column.key,
          label: column.label,
          selected: false,
        }));

        const result = await openOverlay(OVERLAY_KEYS.MANAGE_COLUMNS, {
          availableColumns: [...columns, ...unselectedColumns],
        });

        if (result) {
          this.allColumns = result.allColumns;

          const { selectedColumns } = result;

          if (!selectedColumns.length) {
            return;
          }

          const allColumns = selectedColumns.map(selectedColumn =>
            CONFIG.find(column => column.key === selectedColumn.key),
          );

          this.config = allColumns;
          this.selectedItems = Array(this.model.length).fill(false);

          this.onSetColumns(this.config);
        }
      },
      onSelectCheckbox: (_, index) => {
        const indexInAllItems = index + this.__pageIndex * PAGE_SIZE;

        const newSelectedItems = [...this.selectedItems];
        newSelectedItems[indexInAllItems] = !newSelectedItems[indexInAllItems];

        this.selectedItems = newSelectedItems;
      },
      onSelectAll: () => {
        const allSelected = this.selectedItems.every(item => item === true);

        this.selectedItems = Array(this.model.length).fill(!allSelected);
      },
      addFollowUp: async () => {
        const selectedRows = this.selectedItems
          .map((isSelected, index) => (isSelected ? this.model[index] : null))
          .filter(item => item !== null);

        const result = await openPopup(POPUP_RENDER_KEYS.AR_HUB_ADD_FOLLOW_UP, {
          date: null,
          description: '',
          selectedItems: selectedRows,
          editMode: false,
        });

        if (result) {
          this.onFollowUpAdded(result);
        }
      },
      viewNotes: async index => {
        const result = await openOverlay(OVERLAY_KEYS.INVOICE_NOTES, {
          invoiceId: this.model[index].invoiceId,
        });

        return result;
      },
      updateBilledStatus: async () => {
        const { invoiceNumbers, invoiceIds } = this.selectedItems.reduce(
          (acc, isSelected, index) => {
            if (isSelected) {
              const row = this.model[index];
              acc.invoiceNumbers.push(row.invoiceNumber);
              acc.invoiceIds.push(row.invoiceId);
            }

            return acc;
          },
          { invoiceNumbers: [], invoiceIds: [] },
        );

        const result = await openPopup(
          POPUP_RENDER_KEYS.AR_HUB_UPDATE_BILLED_STATUS,
          {
            invoiceNumbers,
            billedStatuses: this.billedStatuses,
          },
        );

        try {
          if (result !== false) {
            await bulkUpdateBilledStatus({
              invoiceIds,
              billedStatus: result,
            });

            store.dispatch(openSuccess('Billed status updated successfully.'));

            this.onUpdateBilledStatus();
          }
        } catch (error) {
          console.error(error);

          store.dispatch(openError('Error updating billed status.'));
        }
      },
      onPrimaryPayerClick: rowIndex => this.onPrimaryPayerClick(rowIndex),
      onSecondaryPayerClick: rowIndex => this.onSecondaryPayerClick(rowIndex),
      pageChanged: pageIndex => {
        this.__pageIndex = pageIndex;
        this.__pagedItems = this.model.slice(
          this.__pageIndex * PAGE_SIZE,
          (this.__pageIndex + 1) * PAGE_SIZE,
        );

        this.__selectedItemsForCurrentPage = this.selectedItems.slice(
          this.__pageIndex * PAGE_SIZE,
          (this.__pageIndex + 1) * PAGE_SIZE,
        );

        // Scroll to pagination element after DOM updates to prevent shifting
        requestAnimationFrame(() => {
          const paginationElement = this.shadowRoot.getElementById(
            ELEMENTS.pagination.id,
          );

          if (paginationElement) {
            paginationElement.scrollIntoView({
              behavior: 'instant',
              block: 'start',
            });
          }
        });
      },
    };
  }

  __calculateTotals(charges) {
    const totals = charges.reduce(
      (acc, charge) => {
        acc.billedAmount += charge.billedAmount;
        acc.allowedAmount += charge.allowedAmount;
        acc.adjustmentAmount += charge.adjustmentAmount;
        acc.payerBalance += charge.payerBalance;
        acc.patientBalance += charge.patientBalance;
        acc.balance += charge.balance;
        return acc;
      },
      {
        billedAmount: 0,
        allowedAmount: 0,
        adjustmentAmount: 0,
        payerBalance: 0,
        patientBalance: 0,
        balance: 0,
      },
    );

    return totals;
  }

  updated(changedProperties) {
    if (changedProperties.has('columns') && this.columns) {
      const columns = this.columns.map(column => {
        const config = CONFIG.find(c => c.key === column.columnKey);
        return {
          ...config,
        };
      });

      this.config = columns;
    }

    if (changedProperties.has('model')) {
      this.selectedItems = Array(this.model.length).fill(false);
      this.__selectedItemsForCurrentPage = [];

      this.__pageIndex = 0;
      this.__pageCount = Math.ceil(this.model.length / PAGE_SIZE);

      this.__pagedItems = this.model.slice(
        this.__pageIndex * PAGE_SIZE,
        (this.__pageIndex + 1) * PAGE_SIZE,
      );

      this.__totals = this.__calculateTotals(this.model);
    }

    if (changedProperties.has('selectedItems')) {
      this.__selectedItemsForCurrentPage = this.selectedItems.slice(
        this.__pageIndex * PAGE_SIZE,
        (this.__pageIndex + 1) * PAGE_SIZE,
      );
    }
  }

  __renderButtons() {
    const hasSelectedItems =
      this.selectedItems && this.selectedItems.some(item => item === true);

    return html`
      <div class="button-container">
        <div class="left-buttons">
          <neb-button-action
            id="${ELEMENTS.addFollowUpButton.id}"
            label="Add Follow Up"
            leadingIcon="followUp"
            .onClick="${this.__handlers.addFollowUp}"
            ?disabled="${!hasSelectedItems}"
          ></neb-button-action>
          <neb-button-action
            id="${ELEMENTS.updateBilledStatusButton.id}"
            label="Update Billed Status"
            leadingIcon="updateAll"
            .onClick="${this.__handlers.updateBilledStatus}"
            ?disabled="${!hasSelectedItems}"
          ></neb-button-action>
        </div>
        <div class="right-buttons">
          <neb-button-action
            id="${ELEMENTS.showHideColumnsButton.id}"
            label="Show/Hide Columns"
            leadingIcon="visibilityOff"
            .onClick="${this.__handlers.showHideColumns}"
          ></neb-button-action>
          <neb-button-menu
            id="${ELEMENTS.exportDataButton.id}"
            class="export-data-button"
            .mode="${MODE.DROPDOWN_MENU}"
            .items="${[
              {
                label: 'Export Data',
                truncate: false,
                icon: 'neb:download',
                onClick: () => this.__handlers.exportData(false),
              },
              {
                label: 'Include Pt./Ins Info',
                truncate: false,
                icon: 'neb:download',
                onClick: () => this.__handlers.exportData(true),
              },
            ]}"
          ></neb-button-menu>
        </div>
      </div>
    `;
  }

  __renderTable() {
    const emptyMessage = this.showFilterPrompt
      ? FILTER_PROMPT_MESSAGE
      : EMPTY_MESSAGE;

    return html`
      <neb-table-ar-hub
        id="${ELEMENTS.table.id}"
        .config="${this.config}"
        .emptyMessage="${emptyMessage}"
        .model="${this.__pagedItems}"
        .totals="${this.__totals}"
        .selectedTab="${this.selectedTab}"
        .selectedItems="${this.__selectedItemsForCurrentPage}"
        .onSelectCheckbox="${this.__handlers.onSelectCheckbox}"
        .onSelectAll="${this.__handlers.onSelectAll}"
        .onSort="${this.__handlers.onSort}"
        .onClickInvoice="${this.__handlers.onClickInvoice}"
        .onClickCase="${this.__handlers.onClickCase}"
        .onClickERAsEOBs="${this.__handlers.onClickERAsEOBs}"
        .onClickFollowUp="${this.__handlers.onClickFollowUp}"
        .onCompleteFollowUp="${this.__handlers.completeFollowUp}"
        .isInvoiceOverlayClosed="${this.isInvoiceOverlayClosed}"
        .onPrimaryPayerClick="${this.__handlers.onPrimaryPayerClick}"
        .onSecondaryPayerClick="${this.__handlers.onSecondaryPayerClick}"
        .sortParams="${this.sortParams}"
        .onSetSelectedItems="${this.__handlers.onSetSelectedItems}"
        .onViewNotes="${this.__handlers.viewNotes}"
      ></neb-table-ar-hub>
    `;
  }

  __renderPagination() {
    return html`
      <div class="row-container">
        <neb-pagination
          id="${ELEMENTS.pagination.id}"
          class="pagination"
          .pageCount="${this.__pageCount}"
          .currentPage="${this.__pageIndex}"
          .onPageChanged="${this.__handlers.pageChanged}"
        ></neb-pagination>
      </div>
    `;
  }

  render() {
    return html`
      <div class="content">
        ${this.__renderButtons()} ${this.__renderTable()}
        ${this.__renderPagination()}
      </div>
    `;
  }
}

customElements.define(
  'neb-page-ar-hub-new-custom-view',
  NebPageArHubNewCustomView,
);
